(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ch-import-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ch-import-estimate')) {
    customElements.define(
      'ch-import-estimate',
      class ChImportEstimate extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('[data-ch-import-dialog]');
          this.openButton = this.querySelector('[data-ch-import-open]');
          this.externalOpenButton = document.querySelector(`[data-import-estimate-open="${this.dataset.sectionId}"]`);
          this.closeButton = this.querySelector('[data-ch-import-close]');

          this.openButtons = [this.openButton, this.externalOpenButton].filter(Boolean);
          this.openButtons.forEach((button) => button.addEventListener('click', this.openDialog));
          this.closeButton?.addEventListener('click', this.closeDialog);
          this.dialog?.addEventListener('click', this.closeOnBackdrop);

          if (
            typeof subscribe === 'function' &&
            typeof PUB_SUB_EVENTS !== 'undefined' &&
            PUB_SUB_EVENTS.variantChange
          ) {
            this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
              if (String(data.sectionId) !== String(this.dataset.sectionId) || data.variant?.price == null) return;
              this.updateEstimate(Number(data.variant.price));
            });
          }

          this.updateEstimate(Number(this.dataset.priceCents));
        }

        disconnectedCallback() {
          this.openButtons?.forEach((button) => button.removeEventListener('click', this.openDialog));
          this.closeButton?.removeEventListener('click', this.closeDialog);
          this.dialog?.removeEventListener('click', this.closeOnBackdrop);
          this.variantChangeUnsubscriber?.();
        }

        openDialog = () => {
          if (!this.dialog) return;
          if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
          else this.dialog.setAttribute('open', '');
        };

        closeDialog = () => {
          if (!this.dialog) return;
          if (typeof this.dialog.close === 'function') this.dialog.close();
          else this.dialog.removeAttribute('open');
        };

        closeOnBackdrop = (event) => {
          if (event.target === this.dialog) this.closeDialog();
        };

        updateEstimate(priceCents) {
          if (!Number.isFinite(priceCents)) return;

          const shippingCents = Number(this.dataset.shippingCents || 0);
          const upsCents = Number(this.dataset.upsCents || 0);
          const vatCents = this.roundUpToWhole((priceCents + shippingCents) * 0.081);
          const todayCents = this.roundUpToWhole(priceCents);
          const additionalCents = vatCents + upsCents;

          this.updateValue('[data-ch-import-product]', this.roundUpToWhole(priceCents));
          this.updateValue('[data-ch-import-vat]', vatCents);
          this.updateValue('[data-ch-import-ups]', upsCents);
          this.updateValue('[data-ch-import-total]', todayCents + additionalCents);
          this.updateValue('[data-ch-import-today]', todayCents);
          this.updateValue('[data-ch-import-additional]', additionalCents);
        }

        updateValue(selector, cents) {
          this.querySelectorAll(selector).forEach((element) => {
            element.textContent = this.formatMoney(cents);
          });
        }

        roundUpToWhole(cents) {
          return Math.ceil(cents / 100) * 100;
        }

        formatMoney(cents) {
          const currency = this.dataset.currency || 'CHF';

          try {
            return new Intl.NumberFormat('de-CH', {
              style: 'currency',
              currency,
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            }).format(cents / 100);
          } catch (error) {
            return `${currency} ${Math.ceil(cents / 100)}`;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["uk-import-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('uk-import-estimate')) {
    customElements.define(
      'uk-import-estimate',
      class UkImportEstimate extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('[data-uk-import-dialog]');
          this.openButton = this.querySelector('[data-uk-import-open]');
          this.externalOpenButton = document.querySelector(`[data-import-estimate-open="${this.dataset.sectionId}"]`);
          this.closeButton = this.querySelector('[data-uk-import-close]');

          this.openButtons = [this.openButton, this.externalOpenButton].filter(Boolean);
          this.openButtons.forEach((button) => button.addEventListener('click', this.openDialog));
          this.closeButton?.addEventListener('click', this.closeDialog);
          this.dialog?.addEventListener('click', this.closeOnBackdrop);

          if (
            typeof subscribe === 'function' &&
            typeof PUB_SUB_EVENTS !== 'undefined' &&
            PUB_SUB_EVENTS.variantChange
          ) {
            this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
              if (String(data.sectionId) !== String(this.dataset.sectionId) || data.variant?.price == null) return;
              this.updateEstimate(Number(data.variant.price));
            });
          }

          this.updateEstimate(Number(this.dataset.priceCents));
        }

        disconnectedCallback() {
          this.openButtons?.forEach((button) => button.removeEventListener('click', this.openDialog));
          this.closeButton?.removeEventListener('click', this.closeDialog);
          this.dialog?.removeEventListener('click', this.closeOnBackdrop);
          this.variantChangeUnsubscriber?.();
        }

        openDialog = () => {
          if (!this.dialog) return;
          if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
          else this.dialog.setAttribute('open', '');
        };

        closeDialog = () => {
          if (!this.dialog) return;
          if (typeof this.dialog.close === 'function') this.dialog.close();
          else this.dialog.removeAttribute('open');
        };

        closeOnBackdrop = (event) => {
          if (event.target === this.dialog) this.closeDialog();
        };

        updateEstimate(priceCents) {
          if (!Number.isFinite(priceCents)) return;

          const dutyCents = Math.round(priceCents * 0.02);
          const vatCents = Math.round((priceCents + dutyCents + Number(this.dataset.freightCents || 0)) * 0.2);
          const upsCents = Number(this.dataset.upsCents || 0);
          const additionalCents = dutyCents + vatCents + upsCents;

          this.updateValue('[data-uk-import-product]', priceCents);
          this.updateValue('[data-uk-import-duty]', dutyCents);
          this.updateValue('[data-uk-import-vat]', vatCents);
          this.updateValue('[data-uk-import-ups]', upsCents);
          this.updateValue('[data-uk-import-total]', priceCents + additionalCents);
          this.updateValue('[data-uk-import-today]', priceCents, false);
          this.updateValue('[data-uk-import-additional]', additionalCents);
        }

        updateValue(selector, cents, roundToWhole = true) {
          this.querySelectorAll(selector).forEach((element) => {
            element.textContent = this.formatMoney(cents, roundToWhole);
          });
        }

        formatMoney(cents, roundToWhole = true) {
          const currency = this.dataset.currency || 'GBP';

          try {
            return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
              style: 'currency',
              currency,
              minimumFractionDigits: 0,
              maximumFractionDigits: roundToWhole ? 0 : 2,
            }).format(cents / 100);
          } catch (error) {
            const amount = roundToWhole ? Math.round(cents / 100).toString() : (cents / 100).toFixed(2).replace(/\.00$/, '');
            return `${amount} ${currency}`;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["us-import-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('us-import-estimate')) {
    customElements.define(
      'us-import-estimate',
      class UsImportEstimate extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('[data-us-import-dialog]');
          this.openButton = this.querySelector('[data-us-import-open]');
          this.externalOpenButton = document.querySelector(`[data-import-estimate-open="${this.dataset.sectionId}"]`);
          this.closeButton = this.querySelector('[data-us-import-close]');

          this.openButtons = [this.openButton, this.externalOpenButton].filter(Boolean);
          this.openButtons.forEach((button) => button.addEventListener('click', this.openDialog));
          this.closeButton?.addEventListener('click', this.closeDialog);
          this.dialog?.addEventListener('click', this.closeOnBackdrop);

          if (
            typeof subscribe === 'function' &&
            typeof PUB_SUB_EVENTS !== 'undefined' &&
            PUB_SUB_EVENTS.variantChange
          ) {
            this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
              if (String(data.sectionId) !== String(this.dataset.sectionId) || data.variant?.price == null) return;
              this.updateEstimate(Number(data.variant.price));
            });
          }

          this.updateEstimate(Number(this.dataset.priceCents));
        }

        disconnectedCallback() {
          this.openButtons?.forEach((button) => button.removeEventListener('click', this.openDialog));
          this.closeButton?.removeEventListener('click', this.closeDialog);
          this.dialog?.removeEventListener('click', this.closeOnBackdrop);
          this.variantChangeUnsubscriber?.();
        }

        openDialog = () => {
          if (!this.dialog) return;
          if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
          else this.dialog.setAttribute('open', '');
        };

        closeDialog = () => {
          if (!this.dialog) return;
          if (typeof this.dialog.close === 'function') this.dialog.close();
          else this.dialog.removeAttribute('open');
        };

        closeOnBackdrop = (event) => {
          if (event.target === this.dialog) this.closeDialog();
        };

        updateEstimate(priceCents) {
          if (!Number.isFinite(priceCents)) return;

          const upsCents = Number(this.dataset.upsCents || 0);
          const todayCents = this.roundUpToWhole(priceCents);

          this.updateValue('[data-us-import-product]', this.roundUpToWhole(priceCents));
          this.updateValue('[data-us-import-ups]', upsCents);
          this.updateValue('[data-us-import-total]', todayCents + upsCents);
          this.updateValue('[data-us-import-today]', todayCents);
          this.updateValue('[data-us-import-additional]', upsCents);
        }

        updateValue(selector, cents) {
          this.querySelectorAll(selector).forEach((element) => {
            element.textContent = this.formatMoney(cents);
          });
        }

        roundUpToWhole(cents) {
          return Math.ceil(cents / 100) * 100;
        }

        formatMoney(cents) {
          const currency = this.dataset.currency || 'USD';

          try {
            return new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency,
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            }).format(cents / 100);
          } catch (error) {
            return `${currency} ${Math.ceil(cents / 100)}`;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
